export default __webpack_public_path__ + "static/media/path-doughnut-green.5d7b0826.svg";